// The rollover's line about Pending Records (docs/club-records-redesign.md in
// the portal repo, section 2; Doug, 2026-10-23: "We can provide a message at
// rollover that any pending club records will be rejected"). Pending Records
// shows the current season only, so last season's pending results drop off
// it. The number is the badge's count, already in the page's memory: no
// extra request. organisationWord: "club", or "school" for a school, which
// reads "school records" (Doug, 2026-10-27, school words pass 2).
//
// Pure, so it is tested (seasonRollover.test.js): the rollover itself cannot
// be tried on dev without starting a season.
export const pendingRecordsRolloverLine = (pendingCount, organisationWord = 'club') => {
  if (pendingCount === 1) {
    return `The 1 ${organisationWord} record still under Pending Records will be rejected. Approve it before you continue, or add it later with + Add Record.`;
  }
  if (pendingCount > 1) {
    return `The ${pendingCount} ${organisationWord} records still under Pending Records will be rejected. Approve them before you continue, or add them later with + Add Record.`;
  }
  return `Any ${organisationWord} records still under Pending Records will be rejected. Approve them before you continue, or add them later with + Add Record.`;
};
